export default "__VITE_ASSET__c$aic3WR__"